export enum DeviceType {
  DESKTOP = 'DESKTOP',
  ANDROID = 'ANDROID',
  IPHONE = 'IPHONE',
}
